<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>
import HomeLayout from '@/customer/components/Layouts/index.vue'
import Loading from '@/customer/components/Layouts/loading.vue'
import Results from '@/customer/components/Layouts/ResultsLoading.vue'
import NotFound from "@/common/components/errors/notFound.vue";
import panelDefaultLayout from '@/panel/components/Layout/index.vue'
import panelLoginLayout from "@/panel/components/Layout/loginLayout.vue";

import {listen} from "./history";

export default {
  name: 'App',
  components: {
    HomeLayout, Loading, Results , panelDefaultLayout ,  panelLoginLayout , NotFound
  },
  computed: {
    layout() {
      return (this.$route.meta.layout) ? this.$route.meta.layout : "";
    }
  },
  created() {
    listen((route, previousRoute) => {
      this.current = route
    });

    window.addEventListener(
        "popstate",
        event => (this.current = window.location.pathname)
    );
  }
}
</script>